import { Box } from '@mui/material';
import { TextArea } from 'framework/form';
import InterruptionFormSection from '../../shared/InterruptionFormSection';
import RecipientSelectField from '../../shared/inputs/RecipientSelectField';
import { INTERRUPTION_CREATE_FORM_SX } from '../formStyles';
import CallbackAvailabilityNote from '../../shared/CallbackAvailabilityNote';
import FocusedEmergencyCallWarning from '../../shared/FocusedEmergencyCallWarning';

const InterruptionCreateFields = () => (
  <Box sx={INTERRUPTION_CREATE_FORM_SX}>
    <InterruptionFormSection
      step={1}
      title="Select recipient"
      description="Start typing at least 3 symbols to search users"
    >
      <RecipientSelectField />
    </InterruptionFormSection>
    <InterruptionFormSection step={2} title="What do you plan to discuss?">
      <TextArea source="message" label="" placeholder="Describe the agenda for the recipient" rows={3} />
    </InterruptionFormSection>
    <CallbackAvailabilityNote />
    <FocusedEmergencyCallWarning />
  </Box>
);

export default InterruptionCreateFields;
